import { render, staticRenderFns } from "./ConfigurationForm.vue?vue&type=template&id=45ae49ce&scoped=true&"
import script from "./ConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./ConfigurationForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationForm.vue?vue&type=style&index=0&id=45ae49ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ae49ce",
  null
  
)

export default component.exports